import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { MessageService } from './message.service';
import { ClientService } from './client.service';

@Injectable()

export class AuthService {
    private isAdministrator: boolean = false;
    constructor(public router: Router, private loginService: LoginService, private clientService: ClientService, public messageService: MessageService) { }

    public get IsAdministrator(): boolean {
        return this.isAdministrator;
    }

    public updateRole() {
        var tokenData = localStorage.getItem('token');
        if (tokenData != null) {
            var parsed = JSON.parse(tokenData);
            var accessRole = parsed.accessRole;

            switch (accessRole.role) {
                case 1: this.isAdministrator = true; break;
                default: break;
            }
        }
    }

    public IsLoggedIn() {
        var token = localStorage.getItem('token');
        if (token == null) {
            this.loginService.getProfile().subscribe((response: any) => {
                token = JSON.stringify(response);
                localStorage.setItem('token', token);
                localStorage.setItem('displayName', response.owner.displayName);
                this.clientService.updateClients();
                this.updateRole();
                this.router.navigate(['/home']);
                this.messageService.isBusy = false;
            })
        }
        return token != null && token != '{}';
    }

    public IsClientSelected() {
        var lastSelectedClient = localStorage.getItem('selectedClient');
        if (lastSelectedClient !== undefined && lastSelectedClient != null) {
            return true;
        } else {
            return false;
        } 
    }

    public getAuthToken() {
        var access_token = localStorage.getItem('authToken');
        if(access_token !== undefined && access_token != null && access_token != 'null' && access_token.trim() != '') {
            var tokenJson = JSON.parse(access_token);
            return tokenJson.access_token;
        } else {
            return '';
        }
    }
}